import { render, staticRenderFns } from "./CatalogSections.vue?vue&type=template&id=80d4d66a"
import script from "./CatalogSections.vue?vue&type=script&lang=js"
export * from "./CatalogSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports